module.exports = __webpack_public_path__ + "static/visual_5-a732c8d221d11251b35f61ad4c9065ba.jpg";